module.exports = __webpack_public_path__ + "img/garbage_w.b7407be1.svg";